<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import Info from "../info.vue";
import Repair from "../repair.vue";
import Track from "../track.vue";
import Evaluatte from "../evaluate.vue";
import EvaluatteList from "../evaluateList.vue";
import ExpenseAccount from "../expenseAccount.vue";

export default {
  extends: baseList,
  components: {
    info: Info,
    Repair,
    Track,
    Evaluatte,
    EvaluatteList,
    ExpenseAccount,
  },
  data() {
    return {
      makeMain:"",
      menu_name: "",
      table: {
        mname: "work",
        key: "id",
        url: {
          list:"/customer/customer/workOrder/selectList"
        },
        output: false,
        order: "repairTime",
      },
      actions: [
        // {
        //   label: "导出工单",
        //   icon: "md-download",
        //   type: "info",
        //   onClick: this.exportData.bind(this, "资产列表", 3),
        //   auth: "admin/completed/exportData",
        // },
      ],
      menus: [
        {
          label: "待处理",
          name: "workOrder_await_cus",
          auth: "system/workOrder/index",
          badge: { mname: "workstate", scene: "1" },
        },
        {
          label: "处理中",
          name: "workOrder_processing_cus",
          auth: "system/processing/index",
          badge: { mname: "workstate", scene: "2" },
        },
        {
          label: "已完成",
          name: "workOrder_completed_cus",
          auth: "system/completed/index",
        },
      ],
      query: {
        state: 3,
      },
      filters: [
        {
          label: "报修时间",
          KeyEnter: this.search,
          name: "repairTime",
          value: "",
          type: "datetimerange",
        },
        {
          label: "工单类型",
          name: "typeName",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
        {
          label: "资产名称",
          name: "facilityName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "问题描述",
          KeyEnter: this.search,
          name: "descr",
          value: "",
          type: "input",
        },
        {
          label: "科室",
          name: "department",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "资产编号",
          KeyEnter: this.search,
          name: "facilityNum",
          value: "",
          type: "input",
        },
        {
          label: "费用汇总",
          name: "expensesSum",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        /* {
          type: "selection",
          width: 60,
        }, */
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "问题描述",
          key: "descr",
          width: 200,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.descr;
            let tempDescr;
            if (text != null) {
              let arr = text.split(']')
              let tempDate = parseInt(arr[0])
              if (tempDate < 60) {
                tempDescr = '[' + '0h' + tempDate + 'm]'+arr[1]
              } else
              if (tempDate > 60 || tempDate == 60) {
                let hour = Math.floor(tempDate / 60)
                let min = tempDate % 60
                tempDescr = '[' + hour + 'h' + min + 'm]'+arr[1]
              }

            }
            return h('div', [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
                domProps: {
                  title: tempDescr
                }
              }, tempDescr)
            ])
          },
        },
        {
          title: "报修时间",
          minWidth: 150,
          align: "center",
          key: "repairTime",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.repairTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        // {
        //   title: "所在科室",
        //   key: "department",
        //   minWidth: 100,
        //   align: "center",
        //   tooltip: "true",
        // },
        // {
        //   title: "具体位置",
        //   key: "address",
        //   minWidth: 100,
        //   align: "center",
        //   tooltip: "true",
        // },
        {
          title: "工单类型",
          key: "typeName",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        // {
        //   title: "协同工单",
        //   key: "isSynergy",
        //   minWidth: 100,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.isSynergy === 0 ? "否" : "是";
        //     return <span style={{ "font-size": "14px" }}>{text}</span>;
        //   },
        // },

        {
          title: "处理人",
          key: "maintainerName",
          minWidth: 120,
          align: "left",
        },
        {
          title: "处理人电话",
          key: "phone",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        {
          title: "处理内容",
          key: "maintainerContent",
          minWidth: 200,
          tooltip: "true",
          align: "left",
          render: (h, params) => {
            const row = params.row;
            let text ="";
            if (row.sysWorkTracks && row.sysWorkTracks.length > 0){
              for (let i = 0; i < row.sysWorkTracks.length; i++) {
                if (row.sysWorkTracks[i].workState == 3){
                  text = row.sysWorkTracks[i].maintainerContent
                }
              }
            }
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "状态",
          key: "state",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.state === 3 ? "已完成" : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "完成时间",
          minWidth: 150,
          align: "center",
          key: "finishTime",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.finishTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "完成用时",
          minWidth: 150,
          align: "center",
          key: "finishTime",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = (row.finishTime-row.repairTime).slice(11, 19);
            return <span>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = []
              let directives = [
                { name: "auth", value: "admin/completed/info" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff",
                    marginRight: "5px",
                    marginBottom: "5px",
                  }}
                >
                  详情
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let row = param.row;
              // let directives = []
              return (
                <Button
                  size="small"
                  onClick={() => this.toEvaluate(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff",
                    display: row.evaluationType === 1 ? "" : "none",
                    marginRight: "5px",
                    marginBottom: "5px",
                  }}
                >
                  评价
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let row = param.row;
              // let directives = []
              return (
                  <Button
                      size="small"
                      onClick={() => this.toEvaluateList(currentRow)}
                      type="default"
                      style={{
                        border:"none",
                        color: "#4991ff",
                        display: row.evaluationType === 2 ?  "": "none",
                        marginRight: "5px",
                        marginBottom: "5px",
                      }}
                  >
                    评价
                  </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
    this.loadLevelDatas();
    this.loaddeskData();
  },
  methods: {
    async deskChange(query) {
      if (query !== "") {
        setTimeout(async () => {
          let q = {
            deskName: query,
          };

          let res = await $utils.api
            .load(`/customer/customer/desk/list`, q, "get")
              const list = res.rows.map((item) => {
                return {
                  value: item.id,
                  name: item.deskName,
                };
              });
              // let dropList = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);

              for (let index = 0; index < this.filters.length; index++) {
                const element = this.filters[index];
                if (element && element.name == "deskId") {
                  this.filters[index]["dropList"] = list;
                }
              }
        }, 200);
      } else {
        this.dropList = [];
      }
    },
    async loaddeskData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state = 2;
      let res = await $utils.api
        .load(`/customer/customer/desk/list`, q)

          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.deskName;
              xx.children = element.children || [];
              dropList.push(xx);
            }
            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "deskId") {
                this.filters[index]["dropList"] = (
                  element["dropList"] || []
                ).concat(dropList);
              }
            }
          }
    },
    async loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      let res = await $utils.api.load("/customer/customer/workType/list", q)
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.name;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeName") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
    },

    toInfo(row) {
      $utils.url.push({
        name: "workOrder_info_cus",
        query: { action: "edit", kv: row.id },
      });
    },
    toEvaluate(row) {
      this.$Modal.success({
        closable: true,
        title: "评价",
        width: "1000px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Evaluatte
              style={{ margin: "0", color: "#19be6b" }}
              workId={row.id}
            ></Evaluatte>
          );
        },
      });
    },
    toEvaluateList(row) {
      this.$Modal.success({
        closable: true,
        title: "评价",
        width: "1000px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
              <EvaluatteList
                  style={{ margin: "0", color: "#19be6b" }}
                  workId={row.id}
              ></EvaluatteList>
          );
        },
      });
    },
  },
};
</script>
<style scoped></style>
